var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a8e2a822-3d11-419e-851a-77f3b59c6412",
    x1: 6.85,
    y1: 7.226,
    x2: 6.85,
    y2: 18.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2fafb19-725d-413a-bceb-19447c64feab",
    x1: 6.563,
    y1: 1.149,
    x2: 7.391,
    y2: 11.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b89ba70f-40d4-49bf-9168-1914828bbd51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.977,9.2V7.788l-.2-.074-1.511-.5-.4-.966.768-1.634-.991-.991-.2.1-1.412.718-.966-.4-.619-1.709H11.041l-.074.2-.5,1.511-.966.4L7.9,3.676l-.991.991.1.2.718,1.412-.4.966-1.734.619V9.274l.2.074,1.511.5.4.966L6.93,12.445l.99.99.2-.1,1.412-.718.966.4.619,1.709h1.412l.075-.2.495-1.511.966-.4,1.635.768.991-.991-.1-.2-.718-1.412.4-.966Zm-6.193,2.049A2.718,2.718,0,1,1,14.5,8.531,2.715,2.715,0,0,1,11.784,11.249Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.459,16.516a1.215,1.215,0,0,0,1.218-1.21,1.413,1.413,0,0,0-.008-.146c-.478-3.816-2.655-6.923-6.808-6.923C2.635,8.237.455,10.868.03,15.17a1.22,1.22,0,0,0,1.089,1.339,1,1,0,0,0,.122.007Z",
    fill: "url(#a8e2a822-3d11-419e-851a-77f3b59c6412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.926,9.141a3.808,3.808,0,0,1-2.073-.61l2.052,5.361L8.943,8.567A3.81,3.81,0,0,1,6.926,9.141Z",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.898,
    cy: 5.313,
    r: 3.829,
    fill: "url(#a2fafb19-725d-413a-bceb-19447c64feab)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.e846bb6cfc633651d5bc24a740e1663c.svg";
export { ForwardRef as ReactComponent };